import React, { useContext, useState } from 'react'
import { firestore, timestamp } from '../../../firebase'
import StateContext from '../../../StateContext'

function WpMediaListTemplate({image, fbMedia}) {

    const {loggedIn, userId} = useContext(StateContext)

    const [type, setType] = useState("gallery")

    function isAdded(imageUrl) {
        let isAdded = false
        const filteredImages = fbMedia?.filter(imageFB => {
            return imageFB.imageUrl === imageUrl
        })
        
        if (filteredImages?.length > 0) {
            isAdded = true
        }
        return isAdded
    }

    function isAddedToFB(imageUrl) {

        let isAdded;
        const filteredImages = fbMedia.filter((image) => image.imageUrl === imageUrl);
        if (filteredImages?.length > 0) {
            isAdded = true
        }
        return isAdded
    }


    async function addImageHandler() {
        const imageExists = isAddedToFB(image.source_url)
        if (imageExists) {
            return 
        }
        try {
            const imagesRef = firestore.collection("images")
            const data = {
                imageUrl: image.source_url,
                createdAt: timestamp(),
                date_added: new Date().toISOString(),
                user_id: userId,
                type
            }
            imagesRef.add(data);
            console.log("added")
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="col-lg-4 col-xl-3 p-1" style={isAdded(image.source_url) ? {border: "3px solid green"} : {border: "none"}}>
            <img src={image.source_url} alt="" className="img-fluid fixed-image-wide" />
            {loggedIn && (
                <div>
                    {!isAddedToFB(image.source_url) && (
                    <select className="browser-default custom-select" value={type} onChange={e => setType(e.target.value)}>
                    <option value="player">Spillerbilde</option>
                    <option value="gallery">Galleri</option>
                </select>
                    )}

                    <button onClick={addImageHandler} className={`btn btn-block ${isAddedToFB(image.source_url) ? "btn-danger" : "btn-success"}`}>
                        {isAddedToFB(image.source_url) ? "Lagt til" : "Legg til"}
                        <span className="float-right">
                            <i className={isAddedToFB(image.source_url) ? "fas fa-check" : "fas fa-plus"}></i>
                        </span>
                    </button>
                </div>
            )}
        </div>
    )
}
export default WpMediaListTemplate